import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import ExternalApi from "./views/ExternalApi";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";
import Maps from "./components/Maps";
import Forums from "./components/Forums";
import Post from "./components/Post";
import Friends from "./components/Friends"

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isLoading, error, isAuthenticated } = useAuth0();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="">
        <NavBar />
        <main>
          <Switch>
            <Route path="/" exact component={isAuthenticated ? Maps : Home} />
            <Route path="/profile" component={Profile} />
            <Route path="/external-api" component={ExternalApi} />
            <Route path="/forums" component={Forums} />
            <Route path="/post/:postId" component={Post} />
            <Route path="/friends" component={Friends} />
          </Switch>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
